module.exports = __webpack_public_path__ + "static/img/_kykt.feaf1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_kykt.png
// module id = nhhM
// module chunks = 96